import DataHelpers from '../../helpers/DataHelpers'
import NiceData from '../../data/NiceData'
import Store from '../../store/Store'

export default class {
    static getChecklistRef() {
        return DataHelpers.getRootRef().child('app/documentChecklist')
    }
    static deleteChecklist(key) {
        let dataRef = this.getChecklistRef().child('data').child(key)
        dataRef.remove()
        let listRef = this.getChecklistRef().child('list').child(key)
        listRef.remove()
    }

    static deleteDocument(checklistKey, documentKey) {
        let dataRef = this.getChecklistRef().child('data').child(checklistKey).child('data').child(documentKey)
        dataRef.remove()   
    }
    static deleteOption(checklistKey, optionKey) {
        let dataRef = this.getChecklistRef().child('data').child(checklistKey).child('data').child(documentKey)
        dataRef.remove()   
    }

    static fetchPolicyForDocument(document) {
        return new Promise( (resolve, reject) => {
            let checklistKey = document.meta.path.split('/')[3]
            let optionRef = this.getChecklistRef().child('data').child(checklistKey).child('options').child(document.optionKey)
            NiceData.fetchItemSingle(optionRef).then(option => {
                
                let policyRef = this.getChecklistRef().child('data').child(checklistKey).child('policies').child(option.policyKey)
                NiceData.fetchItemSingle(policyRef).then(policy => {
                    resolve(policy)
                })                
            })
        })
    }

    static deletePolicyCascade(policy) {
        let checklistKey = policy.meta.path.split('/')[3]
        let categoryName = policy.category

        let optionsRef = this.getChecklistRef().child('data').child(checklistKey).child('options').orderByChild('policyKey').equalTo(policy.meta.key)
        NiceData.fetchItemsFromFirebase(optionsRef).then(options => {
            options.forEach(option => {
                let documentsRef = this.getChecklistRef().child('data').child(checklistKey).child('documents').orderByChild('optionKey').equalTo(option.meta.key)
                NiceData.fetchItemsFromFirebase(documentsRef).then(documents => {
                    documents.forEach(document => {
                        NiceData.deleteItem(document)
                    })
                })
                NiceData.deleteItem(option)
            })
        })
        NiceData.deleteItem(policy)

        //delete category if no other policies in here...

        let otherPoliciesRef = this.getChecklistRef().child('data').child(checklistKey).child('policies').orderByChild('category').equalTo(categoryName)
        
        NiceData.fetchItemsFromFirebase(otherPoliciesRef).then(policies => {
            
            if(policies.length < 1) {
                let categoriesRef = this.getChecklistRef().child('data').child(checklistKey).child('categories').orderByChild('name').equalTo(categoryName)
                NiceData.fetchItemsFromFirebase(categoriesRef).then(categories => {
                    categories.forEach(category => {
                        NiceData.deleteItem(category)
                    })
                })
            }

        })
    }

    static fetchChecklistTask(tenantKey, checklistKey) {
        console.log('fetchChecklistTask', tenantKey, checklistKey)
        return new Promise( (resolve, reject) => {
            const followUpRef = DataHelpers.getTenantRef(tenantKey).child('tasks').orderByChild('transactionKey').equalTo(checklistKey)
            NiceData.fetchItemsFromFirebase(followUpRef).then(tasks => {
                //console.log('Tasks are: ', tasks)
                let followUpTask = tasks.find(o => o.code == 'document-checklist')
                //console.log('Followup task is ', followUpTask)

                if(followUpTask)
                    resolve(followUpTask)
            }).catch(e => {
                console.error(e)
            })                    
        })
    }
     
}


// WEBPACK FOOTER //
// ./src/pages/SupplierChecklist/ChecklistHelpers.js